module.exports = __webpack_public_path__ + "img/7.8308c880.jpg";